<template>
  <div>
    <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
      :paginate-elements-by-height="1400" filename="hee hee" :pdf-quality="2" :manual-pagination="false" pdf-format="a5"
      pdf-orientation="landscape" pdf-content-width="800px" ref="html2Pdf">
      <section slot="pdf-content">
        <b-container>
          <b-row style="position: relative; height: 147.5mm;border:2x solid black; padding:5px">
            <b-col>
              <b-row align-content="center">
                <b-col cols="auto" class="title mt-2">
                  <b-img src="../LogoCeleste50.png" width="40px"></b-img>
                  Instituto Fueguino de Enseñanza Inglesa
                </b-col>
                <b-col class="informe-proceso mt-3">Informe de progreso</b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="divider-blue mt-2"></div>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col>
                  <b-row>
                    <b-col class="name">{{
      modalPeriodScorebooks.item.x_student_id[1]
    }}</b-col>
                  </b-row>

                  <b-row class="mb-1">
                    <b-col lg="2">
                      <span class="name-items">Año</span> <br />
                      <span class="name-items-data">{{
        modalPeriodScorebooks.item.x_year
      }}</span>
                    </b-col>
                    <b-col>
                      <span class="name-items">Curso</span> <br />
                      <span class="name-items-data">{{
        modalPeriodScorebooks.class.x_product_template_id[1]
      }}</span>
                    </b-col>
                    <b-col lg="7">
                      <span class="name-items">Docente</span> <br />
                      <span class="name-items-data">{{
        modalPeriodScorebooks.class.x_teacher_id[1]
      }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="3" class="mt-2 mr-3">
                  <span class="name-items">Criterios de aprobación</span><br />
                  <div style="font-size: 13px; line-height: 19px">
                    Nota de aprobación:
                    {{ modalPeriodScorebooks.course.x_pass_score }}<br />
                    Asistencia mínima:
                    {{ modalPeriodScorebooks.course.x_attendance }}%
                  </div>
                </b-col>
              </b-row>
              <!-- TITULOS -->
              <b-row class="mt-2">
                <b-col lg="2">
                  <b-col style="line-height: 16px; font-size: 13px" class="table-titles">Periodo</b-col>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col class="table-titles" v-for="(v, k) in modalPeriodScorebooks.items[0].scoretype" :key="k"
                      style="
                    width: 50px;
                    line-height: 15px;
                    font-size: 13px;
                  ">{{ v.display_name }}</b-col>
                  </b-row>
                </b-col>

                <b-col lg="3">
                  <b-row style="height: 100%">
                    <b-col class="table-titles" lg="6" style="line-height: 16px; font-size: 13px">Cumplimiento de
                      Tareas</b-col>
                    <b-col class="table-titles" style="line-height: 16px; font-size: 13px">
                      Asistencia a Clase
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- SCOREBOOKS  -->
              <div v-for="(v, k) in modalPeriodScorebooks.items" :key="k">
                <b-row style="
                border-top: 1px solid #b4b7bd;
              " class="mt-2">
                  <b-col lg="2" class="pt-1" style="
                  border-right: 1px solid #b4b7bd;
                  font-weight: bold;
                  font-size: 14px;
                  line-height:15px;
                ">{{ v.display_name }} </b-col>
                  <b-col>
                    <b-row>
                      <b-col class="text-center pt-1 pb-1" v-for="(v2, k2) in modalPeriodScorebooks.items[0].scoretype"
                        :key="k2 + 'a'" style="
                      border-right: 1px solid #b4b7bd;
                      border-bottom: 1px solid #b4b7bd;
                    ">
                        <div v-if="v.scorebook">
                          <div v-if="v.scorebook.score[v2.key]">
                            {{ v.scorebook.score[v2.key] }}
                          </div>
                          <div v-if="!v.scorebook.score[v2.key]">
                            A
                          </div>
                        </div>
                        <div v-if="!v.scorebook">&nbsp;</div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col lg="3">
                    <b-row style="height: 100%; font-size: 12px">
                      <b-col v-if="v.scorebook" class="text-center  pt-1 pb-1" lg="6" style="
                      border-right: 1px solid #b4b7bd;
                      border-bottom: 1px solid #b4b7bd;
                    ">{{ v.homework }} %</b-col>
                      <b-col v-if="v.scorebook" class="text-center  pt-1 pb-1"
                        style="border-bottom: 1px solid #b4b7bd; text">{{ v.assistance }} %</b-col>
                      <b-col v-if="!v.scorebook" class="text-center  pt-1 pb-1" lg="6" style="
                      border-right: 1px solid #b4b7bd;
                      border-bottom: 1px solid #b4b7bd;
                    ">&nbsp;</b-col>
                      <b-col v-if="!v.scorebook" class="text-center  pt-1 pb-1"
                        style="border-bottom: 1px solid #b4b7bd; text">&nbsp;</b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row style="
                border-left: 1px solid #b4b7bd;
                border-right: 1px solid #b4b7bd;
              ">
                  <b-col lg="2" class="pt-1">
                    <div style="font-size: 12px; line-height: 13px">
                      {{ v.x_start_date }} al <br />
                      {{ v.x_end_date }}
                    </div>
                  </b-col>
                  <b-col class="pt-1">
                    <div v-if="v.scorebook">
                      <div style="font-size: 12px; line-height: 15px;">
                        <div v-if="v.scorebook.x_record_comment_string1 !== false">{{
      v.scorebook.x_record_comment_string1 }}</div>
                      </div>
                      <div style="font-size: 12px; line-height: 15px;">
                        <div v-if="v.scorebook.x_record_comment_string2 !== false">{{
      v.scorebook.x_record_comment_string2 }}</div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="firmas-container" style="position: absolute;top:112mm; width: 210mm;">

                <b-row class="justify-content-md-center">
                  <b-col cols="12" style="font-size: 20px; text-align: center;">
                    <b-img :src="modalPeriodScorebooks.teacher.x_signature" height="60px"></b-img>
                  </b-col>
                  <b-col cols="12" style="text-align: center">{{
      modalPeriodScorebooks.class.x_teacher_id[1]
    }}</b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" style="font-size: 20px; text-align: center;">
                    <b-img :src="modalPeriodScorebooks.sup.x_signature" height="60px"></b-img>
                  </b-col>
                  <b-col cols="12" style="text-align: center">{{
                    modalPeriodScorebooks.course.x_2nd_signature_id[1]
                    }}</b-col>
                </b-row>
              </div>
              <b-row style="position: absolute; bottom: 5mm; width: 210mm">
                <b-col>
                  <div class="divider"></div>
                </b-col>
              </b-row>

              <b-row align-content="center" style="position: absolute; bottom: 0px; width: 210mm">
                <b-col class="footer-title">Instituto Fueguino de Enseñanza Inglesa</b-col>

                <b-col sm="8" class="footer-title" style="text-align: end">Viedma 749- Tel 422520 - WhatsApp 2964-490398
                  - Email secretaria@ifei.com.ar</b-col>
              </b-row>
            </b-col>
          </b-row>

        </b-container>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
// import { FamiliesService } from '@/services/families.service'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  name: 'Boletin',
  props: ['modalPeriodScorebooks'],
  components: {
    VueHtml2pdf
  },
  async created () {

  },
  async mounted () {
    this.$refs.html2Pdf.generatePdf()
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 25px;
}

.informe-proceso {
  font-size: 15px;
  text-align: end;
}

.divider,
.divider-blue {
  height: 2px;
  border: 1px solid #b4b7bd;
}

.divider-blue {
  border: 1px solid #7dcaf6;
}

.name {
  font-size: 20px;
  color: black;
}

.name-items {
  color: #7dcaf6;
  font-size: 14px;
  line-height: 15px;
  font-weight: bold;
}

.name-items-data {
  color: black;
  font-size: 18px;
  line-height: 21px;
}

.test {
  border-bottom: 1px solid #b4b7bd;
}

.text-center {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
}

.table-titles,
.footer-title {
  color: #67696d;
  font-weight: 300;
  font-size: 14px;
}

.footer-title {
  font-size: 12px;
}

.firmas-container {
  display: flex;
  position: absolute;
  bottom: 0px;
  justify-content: space-around;
  align-items: center;
  width: 60%;
  margin: 10px auto;
}
</style>
